$.fn.__tabs = $.fn.tabs;
$.fn.tabs = function (a, b, c, d, e, f) {
	var base = location.href.replace(/#.*$/, '');
	$('ul>li>a[href^="#"]', this).each(function () {
		var href = $(this).attr('href');
		$(this).attr('href', base + href);
	});
	$(this).__tabs(a, b, c, d, e, f);
};

global.selectedTabsRecords = {};
global.saveCurrentTabs = function() {
	$('.tabs[name]').each(function( index ) {
		var currentTab = $(this).find(' > ul .ui-tabs-active, > .tabs__nav__wrap > ul .ui-tabs-active');
		var activePane = $('#' + currentTab.attr('aria-controls'));
		var tabVal = activePane.attr('value');
		if (tabVal === undefined || tabVal === null || tabVal === '') {
			tabVal = currentTab.index();
		}
		selectedTabsRecords[$(this).attr('name')] = tabVal;
	});
}

global.initIvFields = function(target) {
	target.find('.iv__tabs').each(function() {
		registerInput($(this).attr('id'), 'tabs', {})
	})

	target.find('.iv__zoom').each(function() {
		registerInput($(this).attr('id'), 'range', {})
	})
}